export default class ShopHeader extends HTMLElement {
    header: HTMLElement
    headerMobile: HTMLElement
    menu: HTMLElement
    menuItems: NodeListOf<HTMLElement>
    activeDropdown: HTMLElement | null = null
    activeMenuItem: HTMLElement | null = null
    showAnnouncementBar: boolean = false

    constructor() {
        super()

        this.header = this.querySelector('[data-header]')!
        this.headerMobile = this.querySelector('[data-header-mobile]')!
        this.menu = this.querySelector('[data-menu]')!
        this.menuItems = this.querySelectorAll('[data-menu-item]')

        // Add scroll event listener
        window.addEventListener('scroll', this.handleScroll.bind(this))

        this.menuItems.forEach((item) => {
            item.addEventListener('mouseenter', this.handleMenuItemEnter.bind(this))
            item.addEventListener('mouseleave', this.handleMenuItemLeave.bind(this))
        })
        ;(window as any).addEventListener('announcement:update', this.handleAnnouncementUpdate.bind(this))
    }

    private handleAnnouncementUpdate(evt: CustomEvent) {
        this.showAnnouncementBar = evt.detail.show

        if (this.showAnnouncementBar) {
            this.header.classList.add('top-[30px]')
            this.headerMobile.classList.add('top-[30px]')
        } else {
            this.header.classList.remove('top-[30px]')
            this.headerMobile.classList.remove('top-[30px]')
        }
    }

    private handleMenuItemEnter(event: MouseEvent) {
        const target = event.target as HTMLElement
        const hasDropdown = target.hasAttribute('data-has-dropdown')

        this.activeMenuItem = target

        if (hasDropdown) {
            const dropdown = target.nextElementSibling as HTMLElement
            const isDropdown = dropdown?.hasAttribute('data-dropdown')

            if (isDropdown) {
                dropdown.classList.add('block')
                this.activeDropdown = dropdown
            }
        }
    }

    private handleMenuItemLeave(event: MouseEvent) {
        // @ts-ignore
        const target = event.target as HTMLElement

        if (!this.activeDropdown) {
            this.resetStyles()
        }
    }

    private resetStyles() {
        this.activeDropdown?.classList.remove('block')
        this.activeDropdown = null
    }

    private handleScroll() {
        if (window.scrollY > 80) {
            // Desktop Header
            this.header.classList.add('bg-white', '!text-black')
            this.header.classList.add('top-[0px]')
            this.header.classList.add('!fixed')

            if (this.showAnnouncementBar) {
                this.header.classList.remove('top-[30px]')
            }

            // Mobile Header
            this.headerMobile.classList.add('bg-white', '!text-black')
            this.headerMobile.classList.add('top-[0px]')
            this.headerMobile.classList.add('!fixed')

            if (this.showAnnouncementBar) {
                this.headerMobile.classList.remove('top-[30px]')
            }
        } else {
            // Desktop Header
            this.header.classList.remove('bg-white', '!text-black')
            this.header.classList.remove('top-[0px]')
            this.header.classList.remove('!fixed')

            if (this.showAnnouncementBar) {
                this.header.classList.add('top-[30px]')
            } else {
                this.header.classList.remove('top-[30px]')
            }

            // Mobile Header
            this.headerMobile.classList.remove('bg-white', '!text-black')
            this.headerMobile.classList.remove('top-[0px]')
            this.headerMobile.classList.remove('!fixed')

            if (this.showAnnouncementBar) {
                this.headerMobile.classList.add('top-[30px]')
            } else {
                this.headerMobile.classList.remove('top-[30px]')
            }
        }
    }
}

customElements.define('shop-header', ShopHeader)
